import { GridResourceId } from '../reporting/grid-resource.model';

export enum GridRowMutationAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export enum GridRowMutationRequestKeys {
  resourceId = 'resourceId',
  action = 'action',
  rowKey = 'rowKey',
  values = 'values',
}

export interface GridRowMutationRequest {
  [GridRowMutationRequestKeys.resourceId]: GridResourceId;
  [GridRowMutationRequestKeys.action]: GridRowMutationAction;
  [GridRowMutationRequestKeys.rowKey]?: string | number | null;
  [GridRowMutationRequestKeys.values]?: Record<string, unknown> | null;
}

export interface GridRowMutationResponse {
  resourceId: GridResourceId;
  rowKey: string | number | null;
  row: Record<string, unknown> | null;
  recordsTotal: number;
  scopeId?: string | null;
}
